import { Component, OnInit } from "@angular/core";
import { Router, CanActivate } from "@angular/router";
import { constants } from "../constants";
import { AuthGuardService } from "./auth-guard.service";
import { CommonUtilitiesService } from "../common-utilities.service";

@Component({
  selector: "app-auth-guard",
  templateUrl: "./auth-guard.component.html",
  styleUrls: ["./auth-guard.component.scss"]
})
export class AuthGuardComponent implements CanActivate {
  // variables del modal
  isShowModal = false;
  modalTitle = "";
  modalContent = "";

  constructor(
    private _router: Router,
    public LANG: CommonUtilitiesService,
    private authGuardService: AuthGuardService
  ) {}

  /**
   * Description: Método que verifica la sesión del usuario
   * Autor: Diego Diaz
   * @param N/A
   * @return Retorna si esta io no activa la sesión
   */
  canActivate() {
    // Se implementa la promesa para evitar que el metodo canActivate termine primero que
    // el servicio consumido
    return new Promise((resolve, reject) => {

      const userData = JSON.parse(localStorage.getItem("userData"));
      if (userData && userData.token !== "") {
        // Valida que el usuario en sesión tenga una sesión en el backend
        this.authGuardService.validateSessionUserLogged(userData).subscribe(
          valData => {
            if (valData["responseCode"] == constants.SUCCESS_WS_RESPONSE_CODE) {
              resolve();
            } else {
              reject();
            }
          },
          err => {
            reject();
          }
        );
      } else {
        reject();
      }
    }).then(
      () => { // Función que se ejecuta cuando se llama el resolve() en la promesa
        return true; 
      },
      () => { // Función que se ejecuta cuando se llama el reject() en la promesa
        localStorage.clear();
        this._router.navigate([constants.ROUTE_URL_LOGIN]);
        return false;
      }
    );
  }
}
